<template>
  <div class="">
    <form class="form-horizontal">
      <div class="col-md-12 bg_gray">
        <div class="row">
          <div class="col-md-2 top_margin_3">
            <div class="row">

              <label class="col-md-7 col-form-label top_margin_3 and_label">GNOMAD MAX AF &nbsp;&nbsp;&nbsp;<el-checkbox v-model="cufi_chb_gnomad_max_af"> </el-checkbox> </label>
              <div class="col-md-5 top_margin_3">
                <el-input-number :disabled="!cufi_chb_gnomad_max_af" placeholder="" controls-position="right" v-model="cufi_gnomad_max_af" size="small" :precision="4" :step="0.0001" :min="0.0001" :max="1.0000"></el-input-number>
              </div>

            </div>
          </div>

          <div class="col-md-4 top_margin_3">
            <div class="row">

              <label class="col-md-4 col-form-label top_margin_3 and_label">IMPACT</label>
              <div class="col-md-8 top_margin_3">
                <fg-input>
                  <el-select class=""
                            size="small"
                            multiple
                            filterable
                            placeholder=""
                            v-model="cufi_impacts"
                            :disabled="false">
                    <el-option v-for="one in l_impacts"
                              :value="one"
                              :label="one"
                              :key="one">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>

              <label class="col-md-4 col-form-label top_margin_3 and_label">CONSEQUENCE</label>
              <div class="col-md-8 top_margin_3">
                <fg-input>
                  <el-select class=""
                    size="small"
                    multiple
                    filterable
                    :filter-method="select_filter"
                    placeholder=""
                    v-model="cufi_consequences"
                    :disabled="false">
                    <el-option v-for="one in l_consequences"
                              :value="one"
                              :label="one"
                              :key="one">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>

              <label class="col-md-4 col-form-label top_margin_3 and_label">CLINVARS</label>
              <div class="col-md-8 top_margin_3">
                <fg-input>
                  <el-select class=""
                    size="small"
                    multiple
                    filterable
                    :filter-method="select_filter"
                    placeholder=""
                    v-model="cufi_clinvars"
                    :disabled="false">
                    <el-option v-for="one in d_clinvars"
                              :value="one.id_clinvar"
                              :label="one.clinvar"
                              :key="one.id_clinvar">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>

              <label class="col-md-4 col-form-label top_margin_3 and_label">ACMG</label>
              <div class="col-md-8 top_margin_3">
                <fg-input>
                  <el-select class=""
                    size="small"
                    multiple
                    filterable
                    :filter-method="select_filter"
                    placeholder=""
                    v-model="cufi_acmgs"
                    :disabled="false">
                    <el-option v-for="one in d_acmg_sigs"
                              :value="one.mynum"
                              :label="one.mytext"
                              :key="one.mynum">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>

            </div>
          </div>

          <div class="col-md-6 top_margin_3">
            <div class="row bottom_margin_3">
              <label class="col-md-3 col-form-label top_margin_3 and_label">Int. classes</label>
              <div class="col-md-9 top_margin_3">
                <!-- <el-checkbox-group v-model="cufi_my_iclasses" size="small" :disabled="rapp === 'fastras'">
                  <el-checkbox-button v-for="one of l_iclasses" :label="one.id_iclass" :key="one.id_iclass" :value="one.id_iclass">{{one.iclass}}</el-checkbox-button>
                </el-checkbox-group> -->

                <el-select class=""
                  style="width: 100%"
                  size="small"
                  multiple
                  placeholder=""
                  v-model="cufi_my_iclasses"
                  :disabled="rapp === 'fastras'"
                  >
                  <el-option v-for="one of l_iclasses"
                            :value="one.id_iclass"
                            :label="one.iclass"
                            :key="one.id_iclass">
                  </el-option>
                </el-select>
              </div>

              <label class="col-md-3 col-form-label top_margin_3 and_label">PSEUDOPANELS</label>
              <div class="col-md-9 top_margin_3">
                <el-select class=""
                  style="width: 100%"
                  size="small"
                  multiple
                  @change="pseudopanels_change"
                  placeholder=""
                  v-model="cufi_my_pseudopanels"
                  :disabled="rapp === 'fastras'"
                  >
                  <el-option v-for="one in Object.keys(d_pseudopanels)"
                            :value="one"
                            :label="one"
                            :key="one">
                  </el-option>
                </el-select>
              </div>

              <label class="col-md-3 col-form-label top_margin_3 and_label"> HPO </label>
              <div class="col-md-9 top_margin_3">
                <el-button class="button_icon blue" plain @click.native="click_modal_hpo_terms()" size="small">Show HPO TERMS</el-button>
              </div>

              <label class="col-md-3 col-form-label top_margin_3 and_label"> GENES </label>
              <div class="col-md-9 top_margin_3">
                <el-button class="button_icon blue" plain @click="click_modal_genes()" size="small">Show {{ cufi_genes.length }} genes</el-button>
                <el-button class="button_icon orange" plain @click="cufi_genes_del()" size="small">Delete all genes</el-button>
              </div>


            </div>
          </div>



        </div>

        <el-divider />

        <div class="row">

          <div class="col-md-3">
            <el-select
              class="select-info"
              v-model="cufi_selected"
              placeholder="Select filter"
              style="width: 90%"
              filterable
              @change="cufi_change"

              >
              <el-option
                class="select-info"
                v-for="item of l_cufis"
                :key="item.id_cufi"
                :label="item.cufi_name"
                :value="item.id_cufi"
                >
                <span v-if="item.cufi_lock" style="float: left"> <i class="el-icon-lock"></i> {{ item.cufi_name }} </span>
              </el-option>
            </el-select>
          </div>

          <div class="col-md-9 bottom_margin_3">
            <el-button-group>
              <el-button :disabled="!(cufi_selected > 1) || cufi.cufi_lock" type="success" style="width: 150px" @click.native="cufi_save"> SAVE </el-button>
              <el-button type="success" plain style="width: 150px" @click.native="cufi_save_as"> SAVE AS </el-button>
              <el-button type="info" disabled style="width: 10px"> &nbsp; </el-button>
              <el-button :disabled="!(cufi_selected > 1)" style="width: 150px" @click.native="cufi_set_default"> SET AS DEFAULT </el-button>
              <el-button type="primary" style="width: 150px" @click.native="cufi_load_default"> LOAD DEFAULT </el-button>
              <el-button type="info" disabled style="width: 10px"> &nbsp; </el-button>
              <el-button type="warning" style="width: 150px" @click.native="clean_filter"> CLEAN </el-button>
              <el-button :disabled="!(cufi_selected > 1) || cufi.cufi_lock" type="danger" style="width: 150px" @click.native="cufi_delete"> DELETE </el-button>
              <el-button type="info" disabled style="width: 30px"> &nbsp; </el-button>
              <el-button type="info" plain style="width: 150px" @click.native="show_vars(true)"> SHOW VARIANTS </el-button>
            </el-button-group>
          </div>

        </div>
      </div>
    </form>


    <el-dialog :visible.sync="modal_genes" title="Genes in current filter" class="my_dialog_1" width="1000px" center draggable @close="close_modal_genes()" :close-on-click-modal="false">
      <el-row>
        <el-col :span="24">
          <h1 class="white-set-mod"></h1>
        </el-col>
      </el-row>
      <div class="modal_col_bg_1">
        <el-row :gutter="10" justify="space-between">
          <el-col :span="10" class="mb-15">
            <el-input
              v-model="genes_search"
              size=""
              class="top_margin_10"
              placeholder="Type to search Gene" />
          </el-col>
          <el-col :span="10" :offset="4" class="mb-15">
            <el-select
              v-model="genes_add"
              style="width: 85%"
              filterable
              clearable
              placeholder="Type 2 min. chars ... to add Gene"
              remote
              :remote-method="remoteGene"
              :loading="remote_gene_loading"
              >
              <el-option
                v-for="one in ac_genes"
                :key="one.id_gene"
                :label="one.gene_symbol"
                :value="one.id_gene"
                >
              </el-option>
            </el-select>
            <el-button type="success" :disabled="genes_add.length < 2 "  @click="click_genes_add" link class="button_icon action" icon="icofont-ui-add"><el-icon :size="20"><Delete /></el-icon></el-button>

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table
              :data="genes_data.filter(one => one.gene_symbol.includes(genes_search)).slice((pagination_cufi_genes.currentPage -1) * pagination_cufi_genes.perPage, (pagination_cufi_genes.currentPage) * pagination_cufi_genes.perPage)"
              style="width: 100%"
              highlight-current-row
              :max-height="600"
              >
              <el-table-column label="NCBI Gene ID" width="200">
                <template #default="scope">
                  <a
                    v-if="scope.row && scope.row.id_gene"
                    :href="mylink_ncbi_gene_id(scope.row.id_gene)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="my_link"
                  >
                    {{ scope.row.id_gene }}
                  </a>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <el-table-column label="Symbol" min-width="200">
                <template #default="scope">
                  <a
                    v-if="scope.row && scope.row.gene_symbol"
                    :href="mylink_genecards_symbol(scope.row.gene_symbol)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="my_link"
                  >
                    {{ scope.row.gene_symbol }}
                  </a>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <el-table-column
                prop=""
                label=""
                min-width="200"
                >
              </el-table-column>

              <el-table-column
                width="150"
                fixed="right"
                label="Actions"
                align="center"
                class-name="custom-cell"
                label-class-name="custom-cell"
                >
                <template #default="scope">
                  <el-button-group>
                    <el-button type="danger" @click="cufi_gene_delete( scope.row, $event )" size="small" link class="button_icon action" icon="icofont-trash"><el-icon :size="20"><Delete /></el-icon></el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="12">
            <el-button plain class="pagination_mezera" @click="export_selected_genes"> Export selected genes in CSV </el-button>
          </el-col>

          <el-col :span="12">
            <el-pagination
              class="pull-right pagination_mezera"
              :current-page.sync="pagination_cufi_genes.currentPage"
              :page-sizes="pagination_cufi_genes.perPageOptions"
              :page-size="pagination_cufi_genes.perPage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="genes_data.filter(one => one.gene_symbol.includes(genes_search)).length"
              background
              @size-change="sizeChangePage_cufi_genes"
              >
            </el-pagination>
          </el-col>

        </el-row>

      </div>

      <el-row justify="center">
        <el-col :span="24" class="flex-center col-150">

        </el-col>
      </el-row>
    </el-dialog>


    <el-dialog :visible.sync="modal_hpo_terms" title="HPO terms" class="my_dialog_1" width="1000px" center draggable @close="close_modal_hpo_terms()" :close-on-click-modal="false">
      <el-row>
        <el-col :span="24">
          <h1 class="white-set-mod"></h1>
        </el-col>
      </el-row>
      <div class="modal_col_bg_1">
        <el-row :gutter="10" justify="space-between">
          <el-col :span="12" class="mb-15">
            <el-input
              v-model="pagination_hpo_terms.search"
              size=""
              class="top_margin_10"
              placeholder="Type to search HPO"
              clearable
              @keyup.enter.native="a_hpos_get()"
              @clear="a_hpos_get()"
              />
          </el-col>
          <el-col :span="2" class="mb-15">
            <el-button type="primary" @click="a_hpos_get()">
              <i class="icofont-search"></i>
            </el-button>
          </el-col>
          <el-col :span="10" class="mb-15 text-right">
            <div class="vertical-separator"></div>

          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-table
              :data="l_hpos"
              style="width: 100%"
              highlight-current-row
              :max-height="600"
              >
              <el-table-column
                prop="hpo_term_my"
                label="HPO term name"
                min-width="600"
                >
              </el-table-column>
              <el-table-column
                prop="count_genes"
                label="Genes"
                min-width="100"
                align="center"
                >
              </el-table-column>
              <el-table-column
                width="150"
                fixed="right"
                label="Actions"
                align="center"
                class-name="custom-cell"
                label-class-name="custom-cell"
                >
                <template #default="scope">
                  <el-button-group>
                    <el-button type="success" @click="hpo_term_genes_add( scope.row, $event )" size="small" link class="button_icon action" icon="icofont-square-right"><el-icon :size="20"></el-icon></el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="12" :offset="12">
            <el-pagination
              class="pull-right pagination_mezera"
              :current-page.sync="pagination_hpo_terms.currentPage"
              :page-sizes="pagination_hpo_terms.perPageOptions"
              :page-size="pagination_hpo_terms.perPage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination_hpo_terms.total"
              background
              @size-change="sizeChangePage_hpo_terms"
              @current-change="currentChangePage_hpo_terms"
              >
            </el-pagination>
          </el-col>

        </el-row>

      </div>

      <el-row justify="center">
        <el-col :span="24" class="flex-center col-150">

        </el-col>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  export default {
    name: 've_vars_cufi',
    props: {
    },
    components: {
    },


    data () {
      return {
        show: true,
        show_genes: true,
        genes_add: "",

        selects: {
          simple: '',
          multiple: 'ARS'
        },

        l_gt: ["0/1", "1/1", "1/0", "0/0"],
        l_impacts: ["LOW", "HIGH", "MODERATE", "MODIFIER"],

        l_search: [
          {
            key: "pos",
            value: "POSITION"
          },
          {
            key: "snp",
            value: "dbSNP"
          },

        ],

        s_search: '',
        searchQuery_v: '',
        propsToSearch_v: [],
        AC_genes_loading: false,

      }
    },

    computed: {
      ...mapState({
        l_cufis: state => state.l_cufis,
        ve_vars: state => state.ve_vars,
        l_gene: state => state.l_gene,
        l_consequences: state => state.l_consequences,
        l_features: state => state.l_features,
        l_clinvars: state => state.l_clinvars,
        d_clinvars: state => state.d_clinvars,
        l_clinvar_dns: state => state.l_clinvar_dns,
        l_iclasses: state => state.l_iclasses,
        d_a_cols: state => state.d_a_cols,
        d_pseudopanels: state => state.d_pseudopanels,
        pagination_v: state => state.pagination_v,
        sorting_v: state => state.sorting_v,
        fastras_freq: state => state.fastras_freq,
        search_vars_by_select: state => state.search_vars_by_select,
        search_vars_by_value: state => state.search_vars_by_value,
        d_acmg_sigs: state => state.d_acmg_sigs,

        d_cufis: state => state.d_cufis,
        cufi: state => state.cufi,
        cufi_yes: state => state.cufi_yes,
        syn_vars: state => state.cufi.syn_vars,
        id_project: state => state.id_project,
        id_examination: state => state.id_examination,
        id_workflow: state => state.id_workflow,
        selected_exams: state => state.selected_exams,

        remote_gene_loading: state => state.remote_gene_loading,
        ac_genes: state => state.ac_genes,
        l_hpos: state => state.l_hpos,

        pagination_cufi_genes: state => state.pagination_cufi_genes,
        pagination_hpo_terms: state => state.pagination_hpo_terms,

        user_setup: state => state.user_setup,

        token: state => state.token,
        user: state => state.user,
        subject: state => state.subject,
        application: state => state.application,
        app: state => state.app,
        rapp: state => state.rapp,

      }),

      ...mapGetters({
        g_gene: 'g_gene',
        g_examination: 'g_examination',
        g_examination_export: 'g_examination_export',
        g_project: 'g_project',
        g_iclasses: 'g_iclasses',
        g_cufis: 'g_cufis',

        }),

      slider_value: {
        get () { return this.$store.state.slider_value; },
        set (value) { this.$store.commit('m_slider_value', value); }
      },

      cufi_impacts: {
        get () { return this.$store.state.cufi.impacts; },
        set (value) { let mykey = "impacts"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_consequences: {
        get () { return this.$store.state.cufi.consequences; },
        set (value) { let mykey = "consequences"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_clinvars: {
        get () { return this.$store.state.cufi.clinvars; },
        set (value) { let mykey = "clinvars"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_acmgs: {
        get () { return this.$store.state.cufi.acmgs; },
        set (value) { let mykey = "acmgs"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_gnomad_max_af: {
        get () { return this.$store.state.cufi.gnomad_max_af; },
        set (value) { let mykey = "gnomad_max_af"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_genes: {
        get () { return this.$store.state.cufi.genes; },
        set (value) { let mykey = "genes"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_my_iclasses: {
        get () { return this.$store.state.cufi.my_iclasses; },
        set (value) { let mykey = "my_iclasses"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_split_reads: {
        get () { return this.$store.state.cufi.split_reads; },
        set (value) { let mykey = "split_reads"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_syn_vars: {
        get () { return this.$store.state.cufi.syn_vars; },
        set (value) { let mykey = "syn_vars"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_mnv_switch: {
        get () { return this.$store.state.cufi.mnv_switch; },
        set (value) { let mykey = "mnv_switch"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_fil_hompol: {
        get () { return this.$store.state.cufi.fil_hompol; },
        set (value) { let mykey = "fil_hompol"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_fil_repeats: {
        get () { return this.$store.state.cufi.fil_repeats; },
        set (value) { let mykey = "fil_repeats"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_fil_other: {
        get () { return this.$store.state.cufi.fil_other; },
        set (value) { let mykey = "fil_other"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_chb_gnomad_max_af: {
        get () { return this.$store.state.cufi.chb_gnomad_max_af; },
        set (value) { let mykey = "chb_gnomad_max_af"; this.$store.commit('m_cufi', {mykey, value}); }
      },

      cufi_my_pseudopanels: {
        get () { return this.$store.state.cufi.my_pseudopanels; },
        set (value) { let mykey = "my_pseudopanels"; this.$store.commit('m_cufi', {mykey, value}); }
      },


      cufi_selected: {
        get () { return this.$store.state.cufi_selected; },
        set (value) { this.$store.commit('m_cufi_selected', value); }
      },


      modal_hpo_terms: {
        get () { return this.$store.state.modal_cufi_hpo_terms; },
        set (value) { this.$store.commit('m_modal_cufi_hpo_terms', value); }
      },


      modal_genes: {
        get () { return this.$store.state.modal_cufi_genes; },
        set (value) { this.$store.commit('m_modal_cufi_genes', value); }
      },


      genes_search: {
        get () { return this.$store.state.cufi_genes_search; },
        set (value) { this.$store.commit('m_cufi_genes_search', value); }
      },


      genes_data: {
        get () { return this.$store.state.cufi_genes_data; },
        set (value) { this.$store.commit('m_cufi_genes_data', value); }
      },


      // my_pseudopanels: {
      //   get () { return this.$store.state.my_pseudopanels; },
      //   set (value) { this.$store.commit('m_my_pseudopanels', value); }
      // },


    },


    methods: {
      ...mapMutations({
        m_slider_value: 'm_slider_value',
        m_ss_gene: 'm_ss_gene',
        m_vars: 'm_vars',
        m_id_examination: 'm_id_examination',
        m_cufi_yes: 'm_cufi_yes',
        m_fastras_freq: 'm_fastras_freq',
        m_modal_pseudopanels: 'm_modal_pseudopanels',
        m_cufi_selected: 'm_cufi_selected',
        m_cufi_load: 'm_cufi_load',
        m_d_cufis: 'm_d_cufis',
        m_l_cufis: 'm_l_cufis',
        m_l_hpos: 'm_l_hpos',

      }),


      ...mapActions({
        a_ve_vars: 'a_ve_vars',
        a_notify: 'a_notify',
        a_hpo_get: 'a_hpo_get',
        a_ac_genes: 'a_ac_genes',
        a_genes_patch: 'a_genes_patch',
        a_genes_put: 'a_genes_put',
        a_hpos_get: 'a_hpos_get',

      }),


      show_vars(cufi_yes){
        this.cufi.cufi_yes = cufi_yes;
        this.a_ve_vars( {  "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, } );
      },


      select_filter_gene(value){
        this.m_ss_gene(value);
      },


      select_filter(value){
        console.log(value);
      },

      // select_impact(value){
      //   console.log(value);
      //   this.m_cufi_impacts(value);
      // },


      clean_filter() {
        this.show_genes = false;
        this.m_cufi_selected( 1 );
        this.m_cufi_load();

        this.a_ve_vars( {  "search_vars_by_select": this.search_vars_by_select, "search_vars_by_value": this.search_vars_by_value, "cufi": this.cufi, } );

        this.$notify({
          title: 'INFO',
          message: 'The filter has been cleared, and now it displays all variants.',
          type: 'primary',
          position: 'top-right',
        });
      },


      cufi_genes_del() {
          // this.show_genes = false;
          // let mykey = "genes";
          // let myval = [];
          // this.$store.commit('m_cufi', {mykey, myval});
          this.cufi_genes = [];
          this.cufi_my_pseudopanels = [];
      },


      genes_show() {
        this.show_genes = true;
      },


      genes_hide() {
        this.show_genes = false;
      },


      pseudopanels_change (val) {
        let newarray = [];
        for (let one of val) {
          newarray.push(...this.d_pseudopanels[one]);
        }
        newarray.push(...this.cufi_genes);
        let sorted_genes = [...new Set(newarray)].sort()
        this.cufi_genes = sorted_genes;
        this.show_genes = true;
      },


      cufi_gene_delete(row, event) {
        this.cufi_genes = this.cufi_genes.filter(x => x !== row.id_gene);
        this.a_genes_patch( {"w": "cufi", "genes": this.cufi_genes} );
        this.cufi_pseudopanels = [];
      },


      genes_remove (val) {
        this.cufi_my_pseudopanels = [];
      },


      genes_clear () {
        let mykey = "genes";
        let value = [];
        this.$store.commit('m_cufi', {mykey, value});

        this.$store.commit('m_cufi_my_pseudopanels', value);

      },


      export_selected_genes () {
        this.a_genes_put( {"exam": this.id_examination, "genes": this.genes_data} );
      },



      sizeChangePage_cufi_genes(val) {
        this.pagination_cufi_genes.currentPage = 1;
        this.pagination_cufi_genes.perPage = val;
      },


      // cufi_add_pseudopanel() {
      //   this.m_modal_pseudopanels(true);

      // },


      cufi_change(val) {
        this.m_cufi_load();
        this.cufi_genes = this.d_cufis[val].genes;
        this.a_genes_patch( {"w": "cufi", "genes": this.cufi_genes} );
        this.show_vars(true);
      },


      cufi_save() {
        axios.post(process.env.VUE_APP_BE + '/cufi', {cufi: this.cufi}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_d_cufis( response.data["d_cufis"] );
            this.m_l_cufis( response.data["l_cufis"] );

            this.$notify({
              title: 'INFO',
              message: 'Filter was saved',
              type: 'success',
              position: 'top-right',
            });
          }, error => {
            console.log(error);
          });
      },


      cufi_save_as() {
        this.$prompt('Please input name', 'NEW FILTER', {
          confirmButtonText: 'CREATE NEW FILTER',
          cancelButtonText: 'Cancel',
        }).then(({ value }) => {
          this.cufi.id_cufi = null;
          this.cufi.cufi_name = value;
          this.cufi.id_workflow = this.id_workflow;
          this.cufi_selected = null;

          axios.post(process.env.VUE_APP_BE + '/cufi', {cufi: this.cufi}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
            .then(response => {
              this.m_d_cufis( response.data["d_cufis"] );
              this.m_l_cufis( response.data["l_cufis"] );

              this.$alert('New filter is ready.', 'NEW FILTER', {
                confirmButtonText: 'OK',
                callback: action => {
                  if (response.data["cufi_insert"] > 0) {
                    this.cufi_selected = response.data["cufi_insert"];
                    this.cufi.id_cufi = response.data["cufi_insert"];

                  }
                }
              });
            }, error => {
              console.log(error);
            });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Input canceled'
          });
        });

      },


      cufi_set_default() {
        axios.patch(process.env.VUE_APP_BE + '/cufi', {cufi_selected: this.cufi_selected, id_workflow: this.id_workflow}, { withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_d_cufis( response.data["d_cufis"] );
            this.m_l_cufis( response.data["l_cufis"] );

            this.$notify({
              title: 'INFO',
              message: 'Current filter was set as default.',
              type: 'success',
              position: 'top-right',
            });
          }, error => {
            console.log(error);
          });
      },


      cufi_load_default() {
        axios.get(process.env.VUE_APP_BE + '/cufi', { withCredentials: true, params: {id_workflow: this.id_workflow}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
          .then(response => {
            this.m_cufi_selected( response.data["id_cufi_default"] );
            this.m_cufi_load();
            this.show_vars(true);

            this.$notify({
              title: 'INFO',
              message: 'Default filter was loaded.',
              type: 'primary',
              position: 'top-right',
            });
          }, error => {
            console.log(error);
          });
      },


      cufi_delete() {
          this.$confirm("Are you sure?", 'DELETE FILTER?', {
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            type: 'danger',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }).then(() => {
            axios.delete(process.env.VUE_APP_BE + '/cufi', { data: {id_cufi: this.cufi_selected}, withCredentials: true, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
              .then(response => {
                this.cufi_selected = null;
                this.m_d_cufis( response.data["d_cufis"] );
                this.m_l_cufis( response.data["l_cufis"] );

                this.clean_filter()

                this.$notify({
                  title: 'INFO',
                  message: 'Selected filter was deleted.',
                  type: 'primary',
                  position: 'top-right',
                });
              }, error => {
                console.log(error);
              });
          }).catch(() => {

          });


      },


      alertuj(mytext) {
        if (mytext === 1) {
          alert(mytext + " - Benign");
        } else if (mytext === 2) {
          alert(mytext + " - Likely benign");
        } else if (mytext === 3) {
          alert(mytext + " - Uncertain significance");
        } else if (mytext === 4) {
          alert(mytext + " - Likely pathogenic");
        } else if (mytext === 5) {
          alert(mytext + " - Pathogenic");
        } else {
          alert(mytext);
        }
      },


      // XAC_genes(query) {
      //   if ( query.length > 1 ) {
      //     this.AC_genes_loading = true;

      //     axios.get(process.env.VUE_APP_BE + '/ac', { withCredentials: true, params: {'ac_type': 'l_gene', 'ac_data': query}, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8' } })
      //       .then(response => {
      //         this.$store.commit('m_l_gene', response.data["l_gene"]);
      //         this.AC_genes_loading = false;
      //       }, error => {
      //         console.log(error);
      //       });
      //   } else {

      //   }
      // },


      remoteGene(query) {
        if ( (query.length > 1) ) {
          this.a_ac_genes( {"ac_type": "genes", "ac_data": query} );
        } else {

        }
      },


      click_modal_genes() {
        this.a_genes_patch( {"w": "cufi", "genes": this.cufi_genes} );
        this.modal_genes = true;
      },


      close_modal_genes() {
        this.modal_genes = false;
      },


      click_modal_hpo_terms() {
        this.m_l_hpos([]);
        this.pagination_hpo_terms.search = "";
        this.a_hpos_get();
        this.modal_hpo_terms = true;
      },


      close_modal_hpo_terms() {
        this.modal_hpo_terms = false;
      },



      currentChangePage_hpo_terms(val) {
        this.pagination_hpo_terms.currentPage = val;
        this.a_hpos_get();
      },


      sizeChangePage_hpo_terms(val) {
        this.pagination_hpo_terms.currentPage = 1;
        this.pagination_hpo_terms.perPage = val;
        this.a_hpos_get();
      },


      hpo_term_genes_add(row, event) {
        event.stopImmediatePropagation();
        let newarray = [];
        newarray.push(...row.id_genes);
        newarray.push(...this.cufi_genes);
        let sorted_genes = [...new Set(newarray)].sort()
        this.cufi_genes = sorted_genes;
      },


      click_genes_add() {
        let newarray = [];
        newarray.push(this.genes_add);
        newarray.push(...this.cufi_genes);
        let sorted_genes = [...new Set(newarray)].sort()
        this.cufi_genes = sorted_genes;
        this.a_genes_patch( {"w": "cufi", "genes": this.cufi_genes} );
      },


      watch_id_examination (newid, oldid) {
        if (newid !== oldid) {
          if (this.igv_switch) {
            this.m_igv_switch(false);
          }
        }
      },


      watch_cufi_genes (newid, oldid) {
        if (newid && newid.length > 0) {
          console.log(newid.length);
        }
      },


      // watch_app (newval, oldval) {
      //   if (newval !== oldval) {
      //   }
      // },

      mylink_ncbi_gene_id(id_gene) {
        const id = (id_gene === null || id_gene === undefined) ? "" : String(id_gene).trim();
        if (!id) return "";
        return `https://www.ncbi.nlm.nih.gov/gene/${encodeURIComponent(id)}`;
      },

      mylink_genecards_symbol(symbol) {
        const s = (symbol === null || symbol === undefined) ? "" : String(symbol).trim();
        if (!s) return "";
        return `https://www.genecards.org/cgi-bin/carddisp.pl?gene=${encodeURIComponent(s)}`;
      },

    },

    beforeMount () {

    },


    created () {

    },


    mounted () {
      // if (this.rapp === 'fastras') {
      //   this.m_cufi_fastras();
      // } else {
      //   this.m_cufi_default();
      // }
    },


    afterDestroy () {

    },


    watch: {
      id_examination: {
        handler: 'watch_id_examination',
        immediate: true
      },

      // cufi_genes: {
      //   handler: 'watch_cufi_genes',
      //   immediate: true
      // },

      // app: {
      //   handler: 'watch_app',
      //   immediate: true
      // },

    },


  }
</script>

<style scoped lang="scss">
  body {
    margin: 0;
  }

  .btn {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }

  .hranaty {
    border-radius: 2px !important;
  }

  .dolu {
    padding-top: 80px !important;
  }

  .mezera {
    margin-right: 10px !important;
  }

  .bottom_margin_30 {
    margin-bottom: 30px;
  }

  .bottom_margin_3 {
    margin-bottom: 3px;
  }

  .top_margin_3 {
    margin-top: 3px;
  }

  .top_margin_30 {
    margin-top: 30px;
  }

  .top_margin_50 {
    margin-top: 50px;
  }

  .bg_gray {
    background: #b7b9bb !important;
  }

  .bg_white {
    background-color: #FFF !important;
  }

  .gene_blue {
    background-color: #ccfdf3 !important;
    margin-left: 0px !important;
    border-radius: 6px !important;
  }

  .el-tag {
      border-radius: 2px !important;
      margin-left: 3px !important;
      margin-bottom: 3px !important;
  }

  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color:#FFF !important;
    background-color:#0e1a25 !important;
    border-color:#070e14 !important;
    -webkit-box-shadow:-1px 0 0 0 #8cc5ff !important;
    box-shadow:-1px 0 0 0 #8cc5ff !important;
  }

  .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
    border-left-color:#0c151f !important;
  }

  .bg_white_tab {
    background-color: #FFF !important;
    z-index: 9999 !important;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg_blue {
    background-color: #ccfdf3 !important;
  }

  .bg-purple-light {
    background: #eee;
    min-height: 12px;
    padding-left: 4px !important;
  }

  .row-bg {
    padding: 3px 0;
    background-color: #f9fafc;
  }

  .min_height {
    border-radius: 4px;
    height: 30px !important;
  }

  .popover_bg {
    background: #a3bbf1;
  }

  .caret-wrapper {
    display: block !important;

  }

  .and_label {
      font-weight: 900 !important;
      font-size: 11px !important;
      color: rgb(117, 7, 7) !important;
  }

  .my_link {
    color: #0b4aa2 !important;
    text-decoration: underline !important;
    cursor: pointer;
  }

  .my_link:hover {
    color: #083a7d !important;
  }

</style>
